import { Component, OnDestroy, OnInit } from '@angular/core';
import { BlogService } from 'app/blog/blog.service';
import { BlogContent } from 'app/blog/types/blog-content.model';
import { LoggingService } from 'app/wipperoz-core/services/logging.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-recent-blog-articles',
  templateUrl: './recent-blog-articles.component.html',
  styleUrls: ['./recent-blog-articles.component.scss']
})
export class RecentBlogArticlesComponent implements OnInit, OnDestroy {
  latestContent: BlogContent[] = [];

  private unsubscribeAll: Subject<any>;

  constructor(private blogService: BlogService, private loggingService: LoggingService) {
    this.unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.blogService.onResultsChanged.pipe(takeUntil(this.unsubscribeAll)).subscribe(
      (data) => {
        if (data !== null) {
          this.latestContent = this.blogService.latestContent;
        }
      },
      (err) => {
        this.loggingService.logError('Error getting blog content', JSON.stringify(err));
      }
    );

    this.blogService.getBlogContent(this.blogService.options);
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }
}
